import { JSX } from 'preact'
import { memo, createPortal } from 'preact/compat'
import { CSSRule } from '@gsc/types'
import { useSerializeStyle } from './useSerializeStyle'

interface Props {
  style: CSSRule
}

export const SerializedStyle = memo<Props>(function SerializedStyle({ style }): JSX.Element {
  const { serializeStyle } = useSerializeStyle()

  if (style?.name === 'import' && style.params) {
    const link = <link rel="stylesheet" href={style.params} />
    return (
      <>
        {createPortal(link, document.head)}
        {link}
      </>
    )
  }

  return style && <style id={style.id}>{serializeStyle(style)}</style>
})
